import React from 'react'

const MessengerPage = () => {
    return (
        <div>
            Messenger
        </div>
    )
}

export default MessengerPage
